export enum PACKAGE_MEASUREMENT_UNIT {
  BOTTLE = 'BOTTLE',
  JAR = 'JAR',
}

export const PACKAGE_MEASUREMENT_UNIT_LABELS = {
  [PACKAGE_MEASUREMENT_UNIT.BOTTLE]: 'Флакон',
  [PACKAGE_MEASUREMENT_UNIT.JAR]: 'Банка',
};

export enum DOSAGE_UNIT {
  MILLILITERS = 'MILLILITERS',
  GRAMS = 'GRAMS',
  DOSES = 'DOSES',
  THOUSANDS_OF_DOSES = 'THOUSANDS_OF_DOSES',
}

export const DOSAGE_UNIT_LABELS = {
  [DOSAGE_UNIT.MILLILITERS]: 'Миллилитры',
  [DOSAGE_UNIT.GRAMS]: 'Граммы',
  [DOSAGE_UNIT.DOSES]: 'Дозы',
  [DOSAGE_UNIT.THOUSANDS_OF_DOSES]: 'Тысячи доз',
};

export const DOSAGE_UNIT_LABELS_SHORT = {
  [DOSAGE_UNIT.MILLILITERS]: 'мл',
  [DOSAGE_UNIT.GRAMS]: 'гр',
  [DOSAGE_UNIT.DOSES]: 'дозы',
  [DOSAGE_UNIT.THOUSANDS_OF_DOSES]: 'Тысячи доз',
};

export const DRUG_BATCH_HISTORY_OPERATIONS = {
  CREATE: 'Добавлена партия препарата',
  INCREASE: 'Увеличено количество в партии',
  EXPENSE: 'Списано количество из партии',
  DECREASE: 'Уменьшено количество в партии',
  OPEN: 'Создана партия после вскрытия (дробное количество)',
  REMOVE: 'Удалена партия препарата',
  REMOVE_ALL: 'Удален препарат (со всеми партиями)',
};
